/* THIS FILE IS GENERATED ON RUNTIME. DO NOT EDIT */

import { ComponentClassNameFactory } from 'lib/contexts/ComponentClassNameFactory';
import getPropStylesFactory from 'lib/utils/getPropStylesFactory';
import getComponentStylesFactory from 'lib/utils/getComponentStylesFactory';
import getComponentThemeFactory from 'lib/utils/getComponentThemeFactory';
import make_styler from '../index';

export const styles = {
  "headline_variant_default": "italic",
  "headline_size_default": "text-fe-headline-md sm:text-fe-headline-md mb-2 mt-0 sm:mb-2 sm:mt-0",
  "headline_colors_primary": "text-inherit",
  "images_variant_default": "",
  "images_size_default": "",
  "images_colors_primary": "",
  "body_variant_default": "flex flex-col relative",
  "body_size_default": "prose-factbox sm:prose-factbox gap-2",
  "body_colors_default": "text-inherit",
  "variant_default": "relative before:block before:absolute before:bg-cover before:left-0 before:bottom-0 before:bg-center",
  "size_default": "p-3 sm:p-6 before:w-full before:h-full my-6",
  "colors_primary": "before:bg-[url('/image/factbox-background-blob.svg')]"
};

const c = make_styler(styles);

export const propClassName = getPropStylesFactory(c, styles, "ContentFactbox");

export const componentClassName = getComponentStylesFactory(propClassName);

export const componentTheme = getComponentThemeFactory(styles);

export const {
  ClassNameContext,
  ClassNameProvider,
  useClassName,
  useTheme,
} = ComponentClassNameFactory(componentClassName, styles);
  
export default c;